export default __webpack_public_path__ + "static/media/person_3.12bc7c23.jpg";